<ng-container *transloco="let t">
    <div class="admin-card">
        <form [formGroup]="inputForm">

            <div class="pt-4 d-flex justify-content-between">
                <div class="d-flex">
                    <div class="pe-2">
                        <app-select formControlName="eventId" [width]="500"
                                    [items]="eventIds"
                                    [translatedLabels]="eventListLabels"
                        />
                    </div>
                    <app-select formControlName="raceId" [width]="500"
                                [items]="eventMap.get(inputForm.controls['eventId'].value)?.raceIds ?? []"
                                [translatedLabels]="eventMap.get(inputForm.controls['eventId'].value)?.raceLabels ?? []"
                    />
                </div>
                <div>
                    @if (componentType === LeagueRoundResultsComponentType.VIEW) {
                    <div class="d-flex align-items-center">
                      <div class="me-2">
                            <app-rounded-button
                                [btnClass]="'rounded-button--button-black-solid'"
                                [isDisabled]="currentRoundResultsMeta?.hasDuplicates"
                                [label]="t('league.results.recalculate')"
                                (onClick)="recalculate()">
                            <i class="bi bi-arrow-clockwise pe-2"></i>
                            </app-rounded-button>
                        </div>
                         <div class="me-2">
                            <app-rounded-button
                                [btnClass]="'rounded-button--button-black-solid'"
                                [isDisabled]="currentRoundResultsMeta?.hasDuplicates || !currentRoundResultsMeta?.hasResults"
                                [label]="t('league.results.apply.public')"
                                (onClick)="applyToPublic()">
                                <i class="bi bi-upload pe-2"></i>
                            </app-rounded-button>
                        </div>
                        <app-rounded-button [label]="t('league.results.enableEditing')"
                            (onClick)="enableEditing()">
                            <i class="bi bi-pencil-square pe-2"></i>
                        </app-rounded-button>
                    </div>

                    }
                    @else {
                    <div class="d-flex">
                       <div class="me-2">
                            <app-rounded-button [label]="t('app.common.cancel')"
                                    [btnClass]="'rounded-button--black-outline'" (onClick)="cancel()"/>
                       </div>
                       <app-rounded-button
                                    [label]="t('app.common.save')"
                                    (onClick)="savePoints()"
                                    [btnClass]="'rounded-button--solid'"
                       ></app-rounded-button>
                   </div>
                    }
                </div>
            </div>
        </form>
        <div class="d-flex justify-content-between align-items-start pt-3">
            <div>
                <app-filter-panel [groups]="filterGroups"
                                  (filterChange)="onFilterChange($event)"/>

            </div>
            <div>
                <app-toggle
                        className="me-2"
                        [options]="roundResultsContextOptions"
                        [activeValue]="filter.context"
                        (valueChange)="selectRankingContext($event)">
                </app-toggle>
            </div>
        </div>


        <div class="mb-3">
        <app-status-bar [colored]="true" class="mb-3">
            <app-status-item [divider]="true" [iconType]="currentRoundResultsMeta?.hasDuplicates ? 'danger' : 'success'"
                             iconClass="bi bi-people-fill">
                <span class="label">
                    {{t('league.roundResults.status.duplicates')}}
                </span>
                    <span class="value">
                    {{t(currentRoundResultsMeta?.hasDuplicates ?
                        'league.roundResults.hasDuplicates' :
                        'league.roundResults.noDuplicates')}}
                </span>
                    @if (currentRoundResultsMeta?.hasDuplicates) {
                    <span class="sub">
                    {{ t( 'league.roundResults.hint.resolveDuplicates')}}
                    </span>
                    }
            </app-status-item>
            <app-status-item [iconType]="currentRoundResultsMeta?.publicInclusionStatus === PublicInclusionStatus.PENDING_CHANGES ?
                            'warning' :
                            (currentRoundResultsMeta?.publicInclusionStatus === PublicInclusionStatus.APPLIED ?
                            'success' : 'info')"
                             [iconClass]="currentRoundResultsMeta?.publicInclusionStatus === PublicInclusionStatus.PENDING_CHANGES ?
                            'bi bi-eye' :
                            (currentRoundResultsMeta?.publicInclusionStatus === PublicInclusionStatus.APPLIED ?
                            'bi bi-eye-fill' : 'bi bi-eye-slash')"
                >
                <span class="label">
                    {{t('league.roundResults.status.public')}}
                </span>
                    <span class="value">
                   {{t('league.roundResults.publicStatus.' + (currentRoundResultsMeta?.publicInclusionStatus ?? PublicInclusionStatus.NOT_APPLIED))}}
                </span>
                    @if (currentRoundResultsMeta?.publicInclusionStatus === PublicInclusionStatus.APPLIED
                    || currentRoundResultsMeta?.publicInclusionStatus === PublicInclusionStatus.PENDING_CHANGES) {
                    <span class="sub">
                    {{ t('league.roundResults.status.lastApplied') }}
                    {{currentRoundResultsMeta?.appliedAt | localizedDate}}
                    </span>
                    }
            </app-status-item>
        </app-status-bar>
        </div>
        @if (results.length) {
            <div class="table-container public-table" horizontalScrollableTable>
                <table class="table align-middle text-center no-vertical-border table--hover">
                    <thead>
                    <tr>
                        <th sticky [stickyWidth]="70">{{ t('league.results.rank') }}</th>
                        @if (isTeam) {
                                <th sticky [stickyWidth]="200" class="text-start">{{ t('league.results.team') }}</th>
                                <th sticky [stickyWidth]="200">{{ t('league.results.team.members') }}</th>
                                @if (currentRoundResultsMeta?.availableTeamCompositions?.length) {
                                    <th sticky [stickyWidth]="100">{{ t('league.results.team.composition') }}</th>
                                }
                                } @else {
                                <th sticky [stickyWidth]="200" class="text-start">{{ t('league.results.participant') }}</th>
                                <th sticky [stickyWidth]="70">{{ t('app.common.gender') }}</th>
                                <th sticky [stickyWidth]="100">{{ t('league.results.category') }}</th>
                        }
                        <th class="col-min-width-150">{{ t('league.results.time') }}</th>
                        <th class="col-min-width-150">{{ t('league.results.base.points') }}</th>
                        <th class="col-min-width-150">{{ t('league.results.bonus') }}</th>
                        <th class="col-min-width-150">{{ t('league.results.penalty') }}</th>
                        <th class="col-min-width-150">{{ t('league.results.final.points') }}</th>
                        <th class="col-min-width-250">{{ t('league.results.competitor.round.status') }}</th>
                        <th class="col-min-width-250">{{ t('league.results.warning') }}</th>
                        <th sticky [stickyWidth]="100" [stickyRight]="true"></th>
                    </tr>
                    </thead>
                    <tbody infinite-scroll
                           [infiniteScrollDistance]="4"
                           (scrolled)="loadMore()">
                    @for (result of results; track result.competitorId) {
                    @let rankType = (filter?.categoryItemId != null ? 'category' : filter?.gender ? 'gender' : 'absolute');
                    <tr [class.row--excluded]="result.countStatus === RoundCountStatus.NOT_INCLUDED">
                                        <td sticky [stickyWidth]="70">
                    {{ (result.points | leagueRank:rankType:filter.context: result) ?? '-' }}
                    </td>
                    <td sticky [stickyWidth]="200" class="text-start">
                        @if (isTeam) {
                            {{ result.leagueCompetitor?.teamName ?? '-' }}
                        } @else {
                            {{ (result.leagueCompetitor?.firstName ?? '') + ' ' + (result.leagueCompetitor?.lastName ?? '') }}
                        }
                    </td>
                    @if (isTeam) {
                    <td sticky [stickyWidth]="200">
                        @if (result.leagueCompetitor?.teamMembers) {
                        <div class="team-members">
                          @for(member of result.leagueCompetitor!.teamMembers; track member.id) {
                        <div class="team-member-row">
                            <span class="member-name">{{ member.firstName }} {{ member.lastName }}</span>
                            @if (member.sex) {
                            <span class="member-gender" [class]="member.sex === 1 ? 'male' : 'female'">
                            {{ t('app.common.gender.short.' + member.sex) }}
                            </span>
                            }
                        </div>
                        }
                        </div>
                        }
                    </td>
                    @if (currentRoundResultsMeta?.availableTeamCompositions?.length) {
                    <td sticky [stickyWidth]="100">
                        @if (result.leagueCompetitor?.teamComposition) {
                    <div class="team-composition">
                        @if (result.leagueCompetitor!.teamComposition?.maleCount) {
                        {{ result.leagueCompetitor!.teamComposition!.maleCount }}{{t('app.common.gender.short.1')}}
                        }
                        @if (result.leagueCompetitor!.teamComposition?.maleCount && result.leagueCompetitor!.teamComposition?.femaleCount) {
                        +
                        }
                        @if (result.leagueCompetitor!.teamComposition?.femaleCount) {
                        {{ result.leagueCompetitor!.teamComposition!.femaleCount }}{{t('app.common.gender.short.2')}}
                        }
                    </div>
                    }
                    </td>
                    }
                    } @else {
                    <td sticky [stickyWidth]="70">
                        <div class="badge-holder__badge me-1"
                             [class.gender-badge-man]="result.leagueCompetitor?.sex !== 2"
                             [class.gender-badge-women]="result.leagueCompetitor?.sex === 2">
                                                <span class="text-uppercase">
                                                    {{ result.leagueCompetitor?.sex === 1
                                                    ? t('app.common.gender.short.1') :
                                                    result.leagueCompetitor?.sex === 2
                                                        ? t('app.common.gender.short.2') :
                                                        '-' }}
                                                </span>
                        </div>
                    </td>
                    <td sticky [stickyWidth]="100">{{ result.leagueCompetitor?.categoryItemLabel ?? '-' }}</td>
                    }
                    <td>{{ result.competitorResultsDetail | resultsTotalTime }}</td>
                    <td>
                        @if (editEnabled) {
                            <input type="number" class="table-input" [min]="0"
                           [value]="result.points?.basePoints"
                           (change)="onChangePoints(result, 'base', $event)"/>
                        } @else {
                            {{ result.points?.basePoints ?? '-' }}
                        }
                    </td>
                    <td>
                        @if (editEnabled) {
                            <input type="number" class="table-input" [min]="0"
                           [value]="result.points?.bonus"
                           (change)="onChangePoints(result, 'bonus', $event)"/>
                        } @else {
                            {{ result.points?.bonus != null ? '+' + result.points?.bonus : '-' }}
                        }
                    </td>
                    <td>
                        @if (editEnabled) {
                        <input type="number" class="table-input" [min]="0"
                           [value]="result.points?.penalty"
                           (change)="onChangePoints(result, 'penalty', $event)"/>
                        } @else {
                        {{ result.points?.penalty ?? '-' }}
                    }
                    </td>
                    <td>{{ result.points?.totalPoints ?? '-' }}</td>
                     <td>

                     @if (result.countStatus != null) {
                    <div class="d-flex justify-content-center w-100">
                        <div class="tag with-border"
                             [class.green]="result.countStatus === RoundCountStatus.INCLUDED">
                            <p class="text-uppercase">{{ t('league.roundResults.countStatus.' + result.countStatus) }}</p>
                        </div>
                    </div>
                    }

                    </td>
                 <td [class.fw-500]="result.warnings?.length" [class.color-red-600]="result.warnings?.length">
                     <div class="d-flex flex-column fs-12">
                         @for (warning of result.warnings; track warning) {
                    <span>{{ t('league.roundResults.warnings.' + warning) }}</span>

                    }
                    </div>

            </td>
            <td sticky [stickyWidth]="100" [stickyRight]="true">
                <div ngbDropdown class="dropdown dropdown--remove-arrow" container="body">
                    <span class="menu-icon" ngbDropdownToggle>
                        <i class="fas fa-ellipsis-v"></i>
                    </span>
                    <ul ngbDropdownMenu>
                        <li ngbDropdownItem (click)="toggleCountStatus(result)">
                    {{ result.countStatus === 0 ? t('league.roundResults.actions.include') : t('league.roundResults.actions.exclude') }}
                    </li>
                   </ul>
               </div>
        </td>
        </tr>
                    }
                    </tbody>
                </table>
            </div>
        }
        @else if (!isLoading) {
            <app-empty-state [contentKeys]="['emptyState.not.able.to.find']"/>
        }
    </div>
</ng-container>